const MenuLinks = [
  {
    id: 1,
    text: "home",
    url: "/",
    icon: null,
  },
  {
    id: 2,
    text: "about us",
    url: "/about/",
    icon: null,
  },
  {
    id: 3,
    text: "services",
    url: "/services/",
    icon: null,
    subs: [
      {
        text: "buildings",
        url: "/services/buildings",
      },
      {
        text: "industrial infrastructure",
        url: "/services/industrial-infrastructure",
      },
      {
        text: "oil and gas",
        url: "/services/oil-and-gas",
      },
      {
        text: "transport",
        url: "/services/transport",
      },
      {
        text: "urban development",
        url: "/services/urban-development",
      },
      {
        text: "water engineering",
        url: "/services/water-engineering",
      },
    ],
  },
  {
    id: 4,
    text: "projects",
    url: "/projects/",
    icon: null,
  },
  {
    id: 5,
    text: "blog",
    url: "/blog/",
    icon: null,
  },
  {
    id: 6,
    text: "careers",
    url: "/careers/",
    icon: null,
  },
  {
    id: 7,
    text: "partners",
    url: "/partners/",
    icon: null,
  },
  {
    id: 8,
    text: "contact",
    url: "/contact/",
    icon: null,
  },
]

export default MenuLinks
